/**
 * TanStack Query hooks for `cap-periods-hourly-daily-monthly-lifetime`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	capPeriodsHourlyDailyMonthlyLifetimeQueryKeys,
	type CreateCapPeriodsHourlyDailyMonthlyLifetimeBody,
	type ListCapPeriodsHourlyDailyMonthlyLifetimeResponse,
	type CapPeriodsHourlyDailyMonthlyLifetimeRow,
} from "./api";

export function useCapPeriodsHourlyDailyMonthlyLifetimeList(): UseQueryResult<ListCapPeriodsHourlyDailyMonthlyLifetimeResponse, Error> {
	return useQuery({
		queryKey: capPeriodsHourlyDailyMonthlyLifetimeQueryKeys.list(),
		queryFn: list,
	});
}

export function useCapPeriodsHourlyDailyMonthlyLifetimeCreate(): UseMutationResult<CapPeriodsHourlyDailyMonthlyLifetimeRow, Error, CreateCapPeriodsHourlyDailyMonthlyLifetimeBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: capPeriodsHourlyDailyMonthlyLifetimeQueryKeys.all });
		},
	});
}

export function useCapPeriodsHourlyDailyMonthlyLifetimeDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: capPeriodsHourlyDailyMonthlyLifetimeQueryKeys.all });
		},
	});
}
